import {cloneDeep, isNull} from "lodash";
import {create} from "zustand";

export const useFormStore = create((set) => ({
  form: {},
  formErrors: {},
  formVisibleErrors: {},
  setForm: (form) => set((state) => {
    return {
      form: cloneDeep(form),
      formErrors: state.formErrors,
      formVisibleErrors: state.formVisibleErrors,
    };
  }),
  setFormField: (fieldId, value) => set((state) => {
    const result = {...state};
    if (isNull(value)) delete result.form[fieldId];
    else result.form[fieldId] = value;
    return result;
  }),
  clearForm: () => set((state) => {
    return {
      form: {},
      formErrors: state.formErrors,
      formVisibleErrors: state.formVisibleErrors,
    };
  }),

  setFormErrors: (errors) => set((state) => {
    const result = {...state};
    result.formErrors = {...errors};
    return result;
  }),
  clearFormError: (fieldId) => set((state) => {
    const result = {...state};
    delete result.formErrors[fieldId];
    return result;
  }),
  setFormError: (fieldId, value) => set((state) => {
    const result = {...state};
    if (value) result.formErrors[fieldId] = value;
    else delete result.formErrors[fieldId];
    return result;
  }),

  setVisibleErrors: (errors) => set((state) => {
    const result = {...state};
    result.formVisibleErrors = {...errors};
    return result;
  }),
  updateVisibleErrors: (err) => set((state) => {
    const result = {...state};
    if (err) result.formVisibleErrors = {...result.formVisibleErrors, ...err};
    return result;
  }),
  clearVisibleError: (fieldId) => set((state) => {
    const result = {...state};
    delete result.formVisibleErrors[fieldId];
    delete result.formErrors[fieldId];
    return result;
  }),
  setVisibleError: (fieldId, value) => set((state) => {
    const result = {...state};
    if (value) {
      result.formVisibleErrors[fieldId] = value;
      result.formErrors[fieldId] = value;
    }
    else {
      delete result.formVisibleErrors[fieldId];
      delete result.formErrors[fieldId];
    }
    return result;
  }),
}))
